import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { privateRequest } from "services/privateRequest";
import { getProjectId } from "utils/utils";


export const fetchTimeline = createAsyncThunk(
    "timeline/fetchTimeline",
    async ({ epicIds = [], issueTypes = [], statusIds = [], sprintIds = [] } = {}, thunkAPI) => {
        try {
            const params = {};

            if (epicIds.length) params["epic-ids"] = epicIds.join(",");
            if (issueTypes.length) params["issueType"] = issueTypes.join(",");
            if (statusIds.length) params["status-ids"] = statusIds.join(",");
            if (sprintIds.length) params["sprint-ids"] = sprintIds.join(",");

            const projectId = getProjectId();
            const response = await privateRequest.get(
                `/api/projects/${projectId}/timeline`,
                { params }
            );

            return response?.data?.data || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data || error);
        }
    }
);

const initialState = {
    items: [],
    loading: false,
    error: null,
    filters: {
        epicIds: [],
        issueTypes: [],
        statusIds: [],
    },
    filterDropDown: {
        open: false,
        data: null,
    },
};

const timelineSlice = createSlice({
    name: "timeline",
    initialState,
    reducers: {
        setTimelineFilters: (state, action) => {
            state.filters = action.payload;
        },
        clearTimelineFilters: (state) => {
            state.filters = { epicIds: [], issueTypes: [], statusIds: [] };
        },
        setFilterDropDown: (state, action) => {
            state.filterDropDown = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTimeline.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTimeline.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchTimeline.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload?.message || "Failed to load timeline");
            });
    },
});

export const { setTimelineFilters, clearTimelineFilters, setFilterDropDown } =
    timelineSlice.actions;

export default timelineSlice.reducer;
